export const GALLERY_MODE = {
    basic: 'basic',
    fullscreen: 'fullscreen',
    technical: 'technical',
} as const;

export const SLIDER_DIRECTION = {
    horizontal: 'horizontal',
    vertical: 'vertical',
} as const;

export const MEDIA_TYPES = {
    image: 'image',
    youtube: 'youtube',
} as const;

export const SPACE_BETWEEN = {
    cards: 12,
    default: 24,
    galleryButtons: 8,
    galleryButtonsHorizontal: 13,
    mobileGalleryButtons: 16,
} as const;

export const SLIDER_SPEED_SLOW = 1200;
export const SLIDER_SPEED_AUTO = 300;

export const MIN_SWIPE_DISTANCE = 30;

export const SLIDERS_PER_VIEW = {
    auto: 'auto',
    four: 4,
    one: 1,
    six: 6,
} as const;

export const TRUST_SLIDER_DATA = [
    {
        id: '1000000001',
        description: 'Установите приложение SimpleWine и получите 1000\u00A0баллов',
        linkHref: 'https://simplewine.ru/app/',
        linkText: 'Подробнее',
        notForWorkers: true,
        notForPrive: true,
        src: '/images/trust-slider/trust-block-bonuses.webp',
        title: 'Дарим 1000 баллов!',
    },
    {
        id: '1000000002',
        description:
            'Более 9 000 наименований в коллекции: высокие рейтинги, редкие вина и\u00A0культовые релизы от звезд мировой\u00A0величины',
        linkHref: 'https://simplewine.ru/catalog/fineandrare/',
        linkText: 'Смотреть',
        src: '/images/trust-slider/trust-block-collection.webp',
        title: 'Уникальная коллекция вин',
    },
    {
        id: '1000000003',
        description:
            'Персональные скидки, специальные предложения и повышенный кэшбек за заказ с нашей программой лояльности',
        linkHref: '/loyalty/',
        linkText: 'Получить карту',
        needAuth: true,
        src: '/images/trust-slider/trust-block-percent.webp',
        title: 'SimpleWine — это выгодно',
    },
    {
        id: '1000000004',
        description:
            'Уже 30 лет отвечаем за подлинность, хранение и перевозку вин и\u00A0крепких напитков в соответствии с мировыми стандартами',
        linkHref: '/about/',
        linkText: 'Подробнее',
        src: '/images/trust-slider/trust-block-quality.webp',
        title: 'Гарантируем качество',
    },
    {
        id: '1000000005',
        description:
            'Винотеки присутствуют в десятках городов России. Выбирайте ближайший пункт выдачи, а мы доставим туда\u00A0ваш\u00A0заказ',
        linkHref: '/nashi-vinoteki/',
        linkText: 'Выбрать',
        notForWorkers: true,
        notForPrive: true,
        src: '/images/trust-slider/trust-block-winestores.webp',
        title: 'Более 100 винотек',
    },
    {
        id: '1000000006',
        description:
            'Если вам тяжело выбрать, вы всегда можете получить экспертный отзыв по телефону, онлайн или в винотеке',
        linkHref: 'https://simplewine.ru/about/contacts/',
        linkText: 'Задать вопрос',
        src: '/images/trust-slider/trust-block-communication.webp',
        title: 'Мы на связи',
    },
];
